module.exports = __webpack_public_path__ + "img/logo_lb_36px.b76cda33.png";